import { type RefObject, useEffect } from 'react';

type Handler = (event: MouseEvent | TouchEvent | KeyboardEvent) => void;

export const useOnClickOutside = <T extends HTMLElement = HTMLElement>(ref: RefObject<T>, handler: Handler): void => {
  useEffect(() => {
    const listener = (
      event:
        | (MouseEvent & { target: HTMLElement | null })
        | (TouchEvent & { target: HTMLElement | null })
        | (KeyboardEvent & { target: HTMLElement | null })
    ): void => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler(event as MouseEvent | TouchEvent | KeyboardEvent);
    };
    document.addEventListener('mousedown', listener as EventListener);
    document.addEventListener('touchstart', listener as EventListener);
    return () => {
      document.removeEventListener('mousedown', listener as EventListener);
      document.removeEventListener('touchstart', listener as EventListener);
    };
  }, [ref, handler]);
};
